/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ModalBase } from './ModalBase';
import { Typography } from '../typography/Typography';
import { Button } from '../button/Button';

// const Modal = React.forwardRef((props, ref) => {

//   const {
//     'aria-describedby': ariaDescribedby,
//     'aria-labelledby': ariaLabelledby,
//     children,
//     disableEscapeKeyDown = false,
//     onBackdropClick,
//     onClose,
//     open,
//     ...other
//   } = props;

//   const backdropClick = React.useRef();

//   const handleBackdropClick = (event) => {
//     // Ignore the events not coming from the "backdrop".
//     if (!backdropClick.current) {
//       return;
//     }

//     backdropClick.current = null;

//     if (onBackdropClick) {
//       onBackdropClick(event);
//     }

//     if (onClose) {
//       onClose(event, 'backdropClick');
//     }
//   };

//   const containerStyles = [
//     'sui-h-full',
//     'sui-outline-0',
//     'sui-outline-none',
//     'sui-flex',
//     'sui-justify-center',
//     'sui-items-center',
//   ].join(' ');

//   const backgroundStyles = [
//     'sui-m-6',
//     'sui-relative',
//     'sui-overflow-y-auto',
//     'sui-flex',
//     'sui-flex-col',
//     'sui-max-h-full',
//     'sui-max-w-[444px] md:sui-max-w-[900px] xl:sui-max-w-[1500px]',
//     'sui-w-full',
//     'sui-bg-primary',
//     'sui-shadow-2xl'
//   ].join(' ');

//   return (
//     <ModalBase
//       aria-labelledby={ariaLabelledby}
//       aria-describedby={ariaDescribedby}
//       open={open}
//       onClose={onClose}
//       onBackdropClick={handleBackdropClick}
//       ref={ref}
//     >
//       <div className={containerStyles}>
//         <div className={backgroundStyles}>
//           {children}
//         </div>
//       </div>
//     </ModalBase>
//   );
// });

const styles = [
  'sui-absolute',
  'sui-top-2/4 sui-left-2/4',
  'sui--translate-y-2/4 sui--translate-x-2/4',
  'sui-w-[400px]',
  'sui-bg-primary',
  'sui-border-2 sui-border-solid sui-border-inverse',
  'sui-shadow-2xl',
  'sui-p-4'
].join(' ');

const Modal = React.forwardRef((props, ref) => {

  const { open, onClose } = props;

  return (
    <ModalBase
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className={styles}>
        <Typography id="unstyled-modal-title" variant="h2">Text in a modal</Typography>
        <Typography id="unstyled-modal-description" variant="body-base">Aliquid amet deserunt earum!</Typography>
        <Button>One</Button>
      </div>
    </ModalBase>
  );
});

Modal.displayName = 'Modal';

Modal.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

Modal.defaultProps = {
};

export { Modal };